import { FC, useEffect } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import {
  CustomNavigate,
  CustomRouterLink
} from '@app/page-components/shared';
import { NodeType } from '@app/types';
import Utility from '@app/utilities/Utility';
import { CompoundIntentPage } from './compound/page';
import { GlobalIntentPage } from './global/page';
import { HierarchicalIntentPage } from './hierarchical/page';
import { ImportIntentPage } from './import/page';
import { CreateIntentPage } from './management/create/page';
import { EditIntentPage } from './management/edit/page';
import { ImportFromLibraryPage } from './management/import/page';
import { ImportFromCsvPage } from './management/import-from-csv/page';
import { IntentManagementLayout } from './management/layout';
import { ViewIntentPage } from './management/view/page';

export const IntentLayout: FC = () => {
  const { pathname } = useLocation();
  const serialized = window.apm.serialized;
  const { features } = serialized.rootSettings;
  const prompts = serialized.components.objects.filter((x) => {
    return x._class === NodeType.prompt;
  });

  useEffect(() => {
    // When `pathname` changes we want to unmount the property panel widget
    // which is dynamically mounted on `IntentsWidget.js`. It gets unmounted
    // there too but only when the intent authorship flag is disabled.
    Utility.hidePropertyPanel();
  }, [pathname]);

  return (
    <>
      <div id="intents_nav" className="row">
        <div className="col-md-10 col-md-offset-1">
          <div className="title col-md-12">
            <ul className="nav nav-tabs">
              {(!features.intentManagement) ? null : (
                <>
                  <CustomRouterLink to="management/" label="Intent Management" />
                  <div className="break">&nbsp;</div>
                </>
              )}

              <CustomRouterLink to="global/" label="Global Handlers" />
              <div className="break">&nbsp;</div>

              <CustomRouterLink to="compound/" label="Compound Intents" />
              <div className="break">&nbsp;</div>

              <CustomRouterLink to="hierarchical/" label="Hierarchical View" />
              <div className="break">&nbsp;</div>

              <CustomRouterLink to="import/" label="Intent Import" />
            </ul>
          </div>
        </div>
      </div>

      <div className="tab-content col-md-12">
        <div className="tab-pane fade in active">
          <div className="row">
            <div className="col-md-12">
              <Routes>
                {/* Render child routes from the parent `/intent` route (see the `src/pages/index.tsx` component) */}
                {(!features.intentManagement) ? null : (
                  <Route path="management*" element={<IntentManagementLayout />}>
                    <Route path="edit/:id" element={<EditIntentPage />} />
                    <Route path="view/:id" element={<ViewIntentPage />} />
                    <Route path="create" element={<CreateIntentPage />} />
                    <Route path="import" element={<ImportFromLibraryPage />} />
                    <Route path="import-from-csv" element={<ImportFromCsvPage />} />
                    <Route path="*" element={<CustomNavigate to={'/'} />} />
                  </Route>
                )}
                <Route
                  path="global"
                  element={
                    <GlobalIntentPage
                      prompts={prompts}
                      modules={serialized.components.modules}
                      intents={serialized.components.intents}
                    />
                  }
                />
                <Route
                  path="compound"
                  element={
                    <CompoundIntentPage
                      valKey="basic-compoundIntents"
                      value={serialized.compoundIntents}
                    />
                  }
                />
                <Route
                  path="hierarchical"
                  element={
                    <HierarchicalIntentPage
                      valKey="basic-treeData"
                      globalIntents={serialized.globalIntents}
                    />
                  }
                />
                <Route
                  path="import"
                  element={
                    <ImportIntentPage
                      className="custom_script_container"
                      prompts={prompts}
                      modules={serialized.components.modules}
                      intents={serialized.components.intents}
                    />
                  }
                />
                <Route
                  path="*"
                  element={
                    <CustomNavigate
                      to={(features.intentManagement) ? 'management' : 'global'}
                    />
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
